import axios from 'axios'
import { getStripeLanguage } from '../../i18n'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

function buildStripeHeaders() {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  return {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }
}

function normalizeStripeError(error) {
  if (error?.response) {
    const apiMessage =
      error.response.data?.error?.message ||
      error.response.data?.message

    return {
      data: error.response.data,
      responseStatus: error.response.status,
      message: apiMessage || 'Erro ao criar sessão de checkout',
    }
  }

  return {
    data: null,
    responseStatus: 0,
    message: error?.message || 'Erro ao criar sessão de checkout',
  }
}

export const createCheckoutSession = async (body) => {
  const resolvedLanguage = body?.language || getStripeLanguage()
  const config = buildStripeHeaders()

  return await axios
    .post(
      `${BASE_URL}stripe/create-checkout-session`,
      {
        ...body,
        language: resolvedLanguage,
        periodicity: body?.periodicity || 'month',
      },
      config,
    )
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error createCheckoutSession', error.response?.data)
      return normalizeStripeError(error)
    })
}

export const createGuestCheckoutSession = async (body) => {
  const resolvedLanguage = body?.language || getStripeLanguage()

  return await axios
    .post(
      `${BASE_URL}stripe/create-guest-checkout-session`,
      {
        ...body,
        language: resolvedLanguage,
        periodicity: body?.periodicity || 'month',
      },
    )
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      console.log('error createGuestCheckoutSession', error.response?.data)
      return normalizeStripeError(error)
    })
}

export const getAddonPackages = async (language) => {
  const resolvedLanguage = language || getStripeLanguage()
  const config = buildStripeHeaders()

  return await axios
    .get(`${BASE_URL}stripe/addon-packages/${resolvedLanguage}`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      return error
    })
}

export const createAddonCheckoutSession = async (body) => {
  const resolvedLanguage = body?.language || getStripeLanguage()
  const config = buildStripeHeaders()

  return await axios
    .post(
      `${BASE_URL}stripe/create-addon-checkout-session`,
      {
        ...body,
        language: resolvedLanguage,
      },
      config,
    )
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error createAddonCheckoutSession', error.response?.data)
      return normalizeStripeError(error)
    })
}

export const createPortalSession = async (body) => {
  const config = buildStripeHeaders()

  return await axios
    .post(`${BASE_URL}stripe/create-portal-session`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error createPortalSession', error.response?.data)
      return error
    })
}
